<section class="dl-page" aria-labelledby="content-unavailable-title">
  <mtm-content-unavailable-message headingId="content-unavailable-title" (goHome)="goHome()" (goBack)="goBack()" />
</section>
